import {Box, Button, Stack, useTheme} from '@chakra-ui/react'
import {faSync} from '@fortawesome/pro-regular-svg-icons'
import {faPlay} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import isEmpty from 'lodash/isEmpty'
import {SELECTED_GENERATION_OPTION} from '../../../constants/playground'
import useTranslation from 'next-translate/useTranslation'
import {useSkill} from '../../../hooks/useSkill'

interface Props {
  onRedo: () => void
  onGenerateMore: () => void
  onGenerate: () => void
  input: string
  output: string
  maxLength: number
  selectedGenerationType: SELECTED_GENERATION_OPTION
  setSelectedGenerationType: (selectedGenerationType: SELECTED_GENERATION_OPTION) => void
}

const SkillDoubleButton = ({
  onGenerate,
  onRedo,
  onGenerateMore,
  input,
  output,
  maxLength,
  selectedGenerationType,
  setSelectedGenerationType,
}: Props) => {
  const theme = useTheme()

  const {t} = useTranslation()
  const tooLong = input.length + output.length > maxLength

  const {isLoading} = useSkill()

  return (
    <>
      {selectedGenerationType === SELECTED_GENERATION_OPTION.GENERATE_FIRST &&
      ((isEmpty(output) && !isLoading) || (!isEmpty(output) && isLoading) || isLoading) ? (
        <Button
          w={['full', null, null, 'auto']}
          variant='primary'
          rightIcon={<FontAwesomeIcon icon={faPlay} />}
          isLoading={isLoading}
          onClick={() => {
            onGenerate()
          }}
          isDisabled={isEmpty(input) || isLoading || tooLong}>
          {t('skill:block_skill_input_button_main')}
        </Button>
      ) : (
        <Stack
          direction={['column-reverse', null, null, 'row']}
          borderRadius='small'
          w={['full', null, null, 'auto']}
          spacing={0}
          background={theme.colors.brand.primary}>
          <Button
            isLoading={
              selectedGenerationType === SELECTED_GENERATION_OPTION.GENERATE_OTHER && isLoading
            }
            rightIcon={<FontAwesomeIcon icon={faSync} />}
            onClick={() => {
              setSelectedGenerationType(SELECTED_GENERATION_OPTION.GENERATE_OTHER)
              onRedo()
            }}
            variant='primary'
            transform='none !important'
            borderBottomRightRadius={[null, null, null, 0]}
            borderTopRightRadius={0}
            borderTopLeftRadius={[0, null, null, theme.radii.small]}
            isDisabled={isLoading || tooLong}
            background={theme.colors.transparent}>
            {t('skill:block_skill_output_button_main')}
          </Button>
          <Box
            w={['full', null, null, '1px']}
            h={['1px', null, null, 'auto']}
            background={theme.colors.brand.grey}
          />
          <Button
            isLoading={
              selectedGenerationType === SELECTED_GENERATION_OPTION.GENERATE_FOLLOWING && isLoading
            }
            rightIcon={<FontAwesomeIcon icon={faPlay} />}
            onClick={() => {
              setSelectedGenerationType(SELECTED_GENERATION_OPTION.GENERATE_FOLLOWING)
              onGenerateMore()
            }}
            variant='primary'
            transform='none !important'
            borderTopLeftRadius={[theme.radii.small, null, null, 0]}
            borderBottomLeftRadius={0}
            borderBottomRightRadius={[0, null, null, theme.radii.small]}
            isDisabled={isLoading || tooLong}
            background={theme.colors.transparent}>
            {t('common:generate_more_button')}
          </Button>
        </Stack>
      )}
    </>
  )
}

export default SkillDoubleButton
